<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <!-- <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="patientsChart.date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="patientsChart.date"
                    label="Data Prontuário"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="patientsChart.date"
                  scrollable
                  locale="pt-br"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog> -->

              <v-text-field
                v-model="patientsChart.date"
                label="Data"
                :rules="dateRules"
                required
              ></v-text-field>
              <v-textarea
                name="input-7-1"
                :rules="descriptionRules"
                box
                label="Prontuário"
                auto-grow
                value=""
                v-model="patientsChart.description"
              ></v-textarea>
              </v-flex>
              <div class="buttons">
                <v-btn
                  color = 'primary'
                  @click="submit()"
                >
                Salvar
                </v-btn>
                <!-- <v-btn
                  color = 'primary'
                  @click="reset()"
                >
                Cancelar
                </v-btn> -->
              </div>
          </v-layout>
        </v-container>
      </v-form>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapActions, mapGetters } from 'vuex'
  moment.locale('pt-br')
  export default {
    name: 'NewRecord',
    computed: {
      ...mapGetters({ customer: 'customer', auth: 'auth' }),
      ...mapGetters('medicalRecord', ['getListRecord', 'getAvailableAppointments']),
      ...mapGetters('patient', ['getPatient']),
      ...mapGetters('app', ['getTheme', 'getPkg'])
    },
    components: {
    },
    mounted () {
      this.$bus.$on('getMedicalRecord', this.loadingPatient)
    },
    data: () => ({
      modal: false,
      env: process.env,
      dateRules: [
        (v) => !!v || 'Campo requerido!'
      ],
      descriptionRules: [
        (v) => !!v || 'Campo requerido!'
      ],
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: false,
      patientsChart: {
        date: moment().format('DD-MM-YYYY'),
        record: null,
        patient: null,
        doctor: null,
        description: null
      }
    }),
    methods: {
      ...mapActions('medicalRecord', ['setCreateRecord']),
      loadingPatient () {
        if (!this.getPatient) return false
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$bus.$emit('getMedicalRecord', 'profile')
        this.$bus.$emit('closeModal', false)
        // this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      submit () {
        if (!this.getPatient.id) {
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.text = 'Selecione novamente o paciente!'
          return false
        }
        if (this.$refs.form.validate()) {
          this.patientsChart.patient = this.getPatient.id
          this.patientsChart.doctor = this.auth.auth.myClinic.crm
          this.patientsChart.customer = this.customer
          this.patientsChart.record = this.getPatient.id
          this.setCreateRecord(this.patientsChart).then((result) => {
            // this.$refs.form.reset()
            this.patientsChart.description = null
            this.$bus.$emit('getMedicalRecord', 'profile')
            this.$bus.$emit('closeModal', false)
            this.$emit('close', true)
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
              if (err.response.data.errors.password) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.password.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/record/new.vue